import { render, staticRenderFns } from "./MilestoneTemplateDetailNew.vue?vue&type=template&id=27175611&"
import script from "./MilestoneTemplateDetailNew.vue?vue&type=script&lang=js&"
export * from "./MilestoneTemplateDetailNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports